import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tripDuration'
})
export class TripDurationPipe implements PipeTransform {

  transform(startDate: string | Date, endDate: string | Date): string {
    if (!startDate || !endDate) return '';

    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffTime = end.getTime() - start.getTime();

    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

    return diffDays + (diffDays > 1 ? ' days' : ' day');
  }

}
